import { Link } from 'react-router-dom';
import { heroStats, newsList } from '@/mocks/news';

const categoryTone: Record<string, string> = {
  show: 'text-primary-400',
  esports: 'text-secondary-400',
  web: 'text-accent-400',
  film: 'text-accent-400',
  music: 'text-secondary-400',
  ent: 'text-primary-400',
  life: 'text-primary-400',
  hot: 'text-accent-400',
};

export default function HeroSection() {
  const liveItems = newsList.slice(0, 4);

  return (
    <section className="relative w-full overflow-hidden border-b border-background-200">
      <div className="pointer-events-none absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20moody%20abstract%20newsroom%20atmosphere%20with%20deep%20charcoal%20walls%2C%20scattered%20crimson%20and%20amber%20light%20streaks%2C%20blurred%20spotlight%20haze%20and%20subtle%20film%20grain%2C%20cinematic%20editorial%20backdrop%2C%20high%20contrast%2C%20no%20people%20visible&width=1600&height=900&seq=gg-hero-01&orientation=landscape"
          alt="黑料爆料实时情报站氛围配图"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/92 to-background-50/65" />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/20 to-background-50/70" />
      </div>

      <div className="relative mx-auto grid w-full grid-cols-1 gap-10 px-4 pb-14 pt-14 md:px-6 md:pb-20 md:pt-24 lg:grid-cols-12">
        <div className="rise-in lg:col-span-7">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/40 bg-primary-500/10 px-3 py-1.5 text-xs font-label text-primary-400">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-500 opacity-75" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500" />
            </span>
            实时更新中 · 刚刚新增 8 条动态
          </span>

          <h1 className="mt-6 font-heading text-4xl leading-[1.15] text-foreground-950 md:text-6xl">
            黑料爆料
            <span className="mt-1 block text-primary-500">今日新瓜实时更新抢先看</span>
          </h1>

          <p className="mt-6 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
            实时更新列表把刚出的料直接摆在首页，新开场、很快挖出结论，点开即可抢先看。
            不用再去各个群里跳转，一条时间线就能看懂来龙去脉。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#feed"
              className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-label text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-flashlight-fill text-base" />
              查看今日新瓜
            </a>
            <Link
              to="/topics"
              className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-100/70 px-6 py-3.5 text-sm font-label text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-400"
            >
              <i className="ri-layout-grid-line text-base" />
              浏览专题分类
            </Link>
          </div>

          <dl className="mt-10 grid max-w-lg grid-cols-3 gap-4 border-t border-background-200 pt-6">
            {heroStats.map((stat) => (
              <div key={stat.label}>
                <dt className="font-heading text-2xl text-accent-400 md:text-3xl">{stat.value}</dt>
                <dd className="mt-1 text-xs text-foreground-500 md:text-sm">{stat.label}</dd>
              </div>
            ))}
          </dl>
        </div>

        <aside className="lg:col-span-5">
          <div className="rise-in rounded-lg border border-background-200 bg-background-100/85 backdrop-blur">
            <div className="flex items-center justify-between border-b border-background-200 px-5 py-4">
              <h2 className="flex items-center gap-2 font-heading text-lg text-foreground-950">
                <i className="ri-radar-line text-primary-500" />
                实时情报流
              </h2>
              <a
                href="#rank"
                className="flex cursor-pointer items-center gap-1 text-xs font-label text-foreground-500 transition-colors hover:text-accent-400"
              >
                全部热榜
                <i className="ri-arrow-right-s-line" />
              </a>
            </div>
            <ul className="divide-y divide-background-200">
              {liveItems.map((item) => (
                <li key={item.id}>
                  <Link
                    to={`/article/${item.id}`}
                    className="group flex items-start gap-3 px-5 py-4 transition-colors hover:bg-background-200/50"
                  >
                    <span className="mt-1.5 flex h-2 w-2 shrink-0">
                      <span className="h-2 w-2 rounded-full bg-primary-500" />
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="flex items-center gap-2 text-[11px] font-label">
                        <span className={categoryTone[item.categoryId] ?? 'text-foreground-500'}>
                          {item.categoryName}
                        </span>
                        <span className="text-foreground-500">{item.time}</span>
                      </span>
                      <span className="mt-1 block truncate text-sm text-foreground-800 transition-colors group-hover:text-foreground-950">
                        {item.title}
                      </span>
                    </span>
                    <i className="ri-arrow-right-s-line mt-0.5 shrink-0 text-lg text-foreground-500 transition-colors group-hover:text-primary-400" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </aside>
      </div>
    </section>
  );
}